export { default } from './Quiz';
